'use client';

import React, { useEffect, useState } from 'react';
import GlowingButton from '../shared/GlowingButton';
import SocialMedia from '../social/SocialMedia';
import { HiChevronDoubleDown } from 'react-icons/hi';
// import { useAnimateOnScroll } from '@/lib/hooks/useIntersectionObserver';

const HeroSection = () => {
  const [isClient, setIsClient] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  // Comment animasi untuk elemen hero
  // const badgeAnimation = useAnimateOnScroll('animate-fade', 'delay-300');
  // const headlineAnimation = useAnimateOnScroll('animate-slide-up', 'delay-400');
  // const subheadlineAnimation = useAnimateOnScroll(
  //   'animate-slide-up',
  //   'delay-500'
  // );
  // const buttonsAnimation = useAnimateOnScroll('animate-slide-up', 'delay-600');
  // const socialAnimation = useAnimateOnScroll('animate-slide-up', 'delay-700');

  // Deteksi client-side rendering
  useEffect(() => {
    setIsClient(true);
  }, []);

  // Efek untuk melacak posisi mouse
  useEffect(() => {
    if (!isClient) return;

    const handleMouseMove = (e: MouseEvent) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
    };

    window.addEventListener('mousemove', handleMouseMove);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, [isClient]);

  // Simplified scroll function using CSS scroll-behavior
  const handleScrollDown = () => {
    const aboutSection = document.querySelector('#content-sections');
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.scrollTo({
        top: window.innerHeight,
        behavior: 'smooth',
      });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Konten Utama */}
      {/* <div className="flex items-center overflow-hidden"> */}
      <div className="space-y-6 px-1">
        {/* Small Intro Badge */}
        <div
          // ref={badgeAnimation.ref as React.RefObject<HTMLDivElement>}
          // className={`inline-flex items-center gap-2 py-1.5 px-3 rounded-full border border-transparent bg-emerald-500/10 text-emerald-300 text-xs md:text-sm font-medium backdrop-blur-sm ${badgeAnimation.animationClasses}`}
          className="inline-flex items-center gap-2 py-1.5 px-3 rounded-full border border-transparent bg-emerald-500/10 text-emerald-300 backdrop-blur-sm opacity-100"
          data-fade="1"
        >
          <svg
            viewBox="0 0 846.66 846.66"
            className="size-4 fill-current"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M138.64 212.28h121.09c10.3-74.25 74.4-130.24 149.55-130.24h28.1c75.15 0 139.25 55.99 149.55 130.24h121.09c71.5 0 129.92 58.42 129.92 129.93v292.48c0 71.51-58.42 129.93-129.92 129.93H138.64c-71.5 0-129.92-58.42-129.92-129.93V342.21c0-71.51 58.42-129.93 129.92-129.93zm99.12 350.99l-56.14 79.83c-15.64 22.24-49.49-1.58-33.85-23.81l56.15-79.85c-18.78-19.51-30.33-46.05-30.33-75.27 0-59.96 48.61-108.58 108.57-108.58 59.96 0 108.57 48.62 108.57 108.58 0 59.95-48.61 108.57-108.57 108.57-15.82 0-30.84-3.39-44.4-9.47zm44.4-166.21c-37.06 0-67.11 30.05-67.11 67.11 0 37.06 30.05 67.1 67.11 67.1 37.06 0 67.11-30.04 67.11-67.1 0-37.06-30.05-67.11-67.11-67.11zm182.11 266.16c-27.27 0-27.27-41.47 0-41.47h192.07c27.27 0 27.27 41.47 0 41.47H464.27zm0-122.19c-27.27 0-27.27-41.47 0-41.47h192.07c27.27 0 27.27 41.47 0 41.47H464.27zm0 61.09c-27.27 0-27.27-41.46 0-41.46h192.07c27.27 0 27.27 41.46 0 41.46H464.27zm0-122.19c-27.27 0-27.27-41.47 0-41.47h192.07c27.27 0 27.27 41.47 0 41.47H464.27zm0-115.05c-27.27 0-27.27-41.46 0-41.46h154.04c27.28 0 27.28 41.46 0 41.46H464.27zm-162.51-152.6h243.14c-9.92-51.16-55.22-88.77-107.52-88.77h-28.1c-52.3 0-97.6 37.61-107.52 88.77zm406.26 41.46H138.64c-48.6 0-88.46 39.86-88.46 88.47v292.48c0 48.61 39.85 88.46 88.46 88.46h569.38c48.6 0 88.46-39.85 88.46-88.46V342.21c0-48.61-39.86-88.47-88.46-88.47z" />
          </svg>

          <span className="text-sm">Looking for opportunities</span>
        </div>

        {/* Headline - using new typography classes */}
        <h1
          // ref={headlineAnimation.ref as React.RefObject<HTMLHeadingElement>}
          // className={`text-[clamp(2.4rem,8vw,3.75rem)] md:text-5xl font-bold leading-tight tracking-tight text-white max-w-3xl ${headlineAnimation.animationClasses}`}
          className=""
          data-fade="2"
        >
          I'm <span className="gradient-text">AL KINDI</span>
        </h1>

        {/* Sub-headline */}
        <p
          // ref={subheadlineAnimation.ref as React.RefObject<HTMLParagraphElement>}
          // className={subheadlineAnimation.animationClasses}
          className="max-w-2xl opacity-100"
          data-fade="3"
        >
          Bridging the intersection between law & technology — growing my skills
          in M&A and capital markets, and sharing insights on law, tech, and
          crypto through this website.
        </p>

        <div
          // ref={buttonsAnimation.ref as React.RefObject<HTMLDivElement>}
          // className={`flex flex-row gap-4 flex-wrap ${buttonsAnimation.animationClasses}`}
          className="flex flex-row gap-4 flex-wrap opacity-100"
          data-fade="4"
        >
          <GlowingButton
            href="/contact/"
            variant="default"
            iconPosition="right"
          >
            Get in touch
          </GlowingButton>
          <GlowingButton
            onClick={handleScrollDown}
            variant="default"
            iconPosition="down"
          >
            Learn How
          </GlowingButton>
        </div>

        {/* Social Links */}
        <div
          // ref={socialAnimation.ref as React.RefObject<HTMLDivElement>}
          // className={`flex flex-col gap-4 pt-1 ${socialAnimation.animationClasses}`}
          className="flex flex-col gap-4 pt-1 opacity-100"
          data-fade="5"
        >
          <div className="flex items-center gap-6">
            <SocialMedia />
          </div>
        </div>
      </div>
      {/* </div> */}

      {/* Scroll Indicator - Perbaikan posisi dan visibilitas */}
      <div
        className="absolute bottom-8 left-0 right-0 w-full flex justify-center"
        style={{ zIndex: 20 }}
      >
        <button
          onClick={handleScrollDown}
          className="group flex flex-col items-center gap-1 text-neutral-500 hover:text-emerald-400 transition-colors duration-300 px-4 py-2 rounded-full bg-black/20 backdrop-blur-sm"
          aria-label="Scroll to next section"
        >
          <HiChevronDoubleDown className="size-5 animate-bounce" />
        </button>
      </div>
    </section>
  );
};

export default HeroSection;
